import emptyApi from '@epi-api/emptyApi';
import { post } from '@epi-helpers/FetchHelpers';
import { ICreateBenefitGroupsBatchRequest } from '@epi-models/containers/ManageBenefitGroups';
import { USER_TAGS } from '@epi-api/apiTags';

import config from '@epi-config';
import { userApi } from '@epi-api/user';

export const createGroupSettings = async (
  payload: ICreateBenefitGroupsBatchRequest
): Promise<{ data?: []; error?: any }> => {
  try {
    const response: [] | undefined = await post(
      `${config.apiHost}/api/company/benefit-groups/batch`,
      payload
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

export const manageBenefitApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    createGroupSettings: build.mutation<
      [],
      { payload: ICreateBenefitGroupsBatchRequest }
    >({
      queryFn: ({ payload }) => createGroupSettings(payload),
      invalidatesTags: [...USER_TAGS],
      async onQueryStarted(_payload, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          userApi.util.updateQueryData('getDetails', undefined, draft => {
            Object.assign(draft, { isBenefitsSet: true });
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      }
    })
  })
});

export const { useCreateGroupSettingsMutation } = manageBenefitApi;
